import * as React from "react";
const SvgFiRrFlame = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flame_svg__a)">
      <path
        fill="#062147"
        d="M16.63 2.9A92 92 0 0 1 14.178.768 2.95 2.95 0 0 0 11.8.026a2.85 2.85 0 0 0-2.032 1.3 20.4 20.4 0 0 0-2.492 6.45A6 6 0 0 1 6.8 6.96a2 2 0 0 0-3.3-.473 9.07 9.07 0 0 0-2.586 6.421A10.98 10.98 0 0 0 9.136 23.64c.907.229 1.84.347 2.776.352.03 0 .349-.003.478-.012 5.97-.193 10.707-5.093 10.7-11.066-.004-4.53-2.996-7.07-6.46-10.014m-4.743 19.085a3.77 3.77 0 0 1-2.035-.806c-.87-.615-1.445-1.517-1.582-2.557-.17-1.622.83-3.743 2.873-6.139.214-.25.527-.394.857-.392.325-.002.634.14.843.39 1.872 2.222 2.9 4.272 2.9 5.773-.006 1.972-1.548 3.532-3.51 3.722a2 2 0 0 1-.346.01m5.689-1.902c-.06.046-.124.083-.184.127.23-.627.35-1.29.35-1.958 0-2.527-1.834-5.235-3.372-7.062a3.1 3.1 0 0 0-2.366-1.1H12a3.12 3.12 0 0 0-2.376 1.093c-2.445 2.864-3.568 5.437-3.338 7.648.054.513.185 1.015.389 1.49a9.1 9.1 0 0 1-3.758-7.413A7.06 7.06 0 0 1 5 7.828q.346.721.827 1.361a1.85 1.85 0 0 0 1.906.7 1.9 1.9 0 0 0 1.45-1.474 18.7 18.7 0 0 1 2.27-6.022.84.84 0 0 1 .609-.384c.28-.038.561.05.77.241.858.78 1.7 1.5 2.5 2.177 3.338 2.835 5.75 4.883 5.75 8.487a9.03 9.03 0 0 1-3.503 7.171z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flame_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlame;
